import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import { host } from 'sly/config';
import { DynamicLinkProps } from 'sly/hubPage/components/HubDynamicContent/DynamicLink/DynamicLink.types';
import Offer from 'sly/icons/Offer';
import Link from 'sly/system/Link';

export default function DynamicLink({
  to,
  title,
  description,
}: DynamicLinkProps) {
  if (!to || !title || !description) {
    return null;
  }
  const isResourceCenterRoute = to.includes(`${host}${RESOURCE_CENTER_PATH}`);
  const splitPath = to.split(host);
  return (
    <div
      className='font-b-m mb-l flex w-[calc(100%-2rem)] items-center rounded-sm bg-viridian-lighter-90 p-l md:mb-xl md:w-[var(--col6)] lg:w-[var(--col8)]'
      data-tp-id='gen-div-a2805401-a56d-4328-a67a-cd356a318ad6'
    >
      <div data-tp-id='gen-div-aa1fa070-4367-4fcd-b381-f1edf1fae550'>
        <Offer style={{ color: '#1a7473' }} size='l' />
      </div>
      <div
        className='ml-m'
        data-tp-id='gen-div-72bdbe1a-1fd6-4d5c-a554-7282febac1a4'
      >
        <span data-tp-id='gen-span-01c4c66f-0530-4a06-90d3-954304e26344'>
          {description}:{' '}
        </span>
        <Link
          {...{
            [isResourceCenterRoute ? 'to' : 'href']: isResourceCenterRoute
              ? splitPath[splitPath.length - 1]
              : to,
          }}
          data-tp-id='gen-Link-66db9182-b9e7-4004-abeb-664e26775a59'
        >
          {title}
        </Link>
      </div>
    </div>
  );
}
